import { HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ClientService } from '@celerofinancas/ui-http-services';
import { TokenResponse } from '@celerofinancas/ui-oauth';
import { Observable } from 'rxjs';

/**
 * Auth service for handling authentication-related operations
 */
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  /**
   * HttpClient instance for making HTTP requests
   */
  private readonly client = inject(ClientService);

  /**
   * Exchange a token for a session
   *
   * @param id_token user token
   */
  public tokenAuthentication(id_token: string): Observable<HttpResponse<TokenResponse>> {
    return this.client.post('/v2/auth/id_token_authentication', { id_token });
  }
}
